import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import PropTypes from 'prop-types'
import moment from 'moment-timezone'
import subscribeToChannel from '../services/socket'
import callerIdNotification from '../services/notification-helpers'
import {
  selectMenu,
  updatePatientSearch,
  updatePatientsAllLocations,
} from '../state/actions/patient-groups'
import {
  fetchCoredialCalls,
  setPopoverPage,
  setNewContactInfo,
} from '../state/actions/call-log'
import {
  chooseCurrentConversation,
  setCurrConvoMsgType,
} from '../state/actions/current'
import {
  addMessagesToConversationFromNotification,
  getMessagesForConversation,
  storeConversationDetails,
  updateMessageStatus,
  updateConversationMessageType,
} from '../state/actions/conversations-messages'
import { addUnseenConvoId } from '../state/actions/notifications'

const createSocketCbs = component => ({
  connected() {
    console.log('connected')
    component.setState({ isConnected: true })
  },

  disconnected() {
    console.log('disconnected')
    component.setState({ isConnected: false })
  },

  rejected() {
    console.log('rejected')
    component.setState({ isConnected: false })
  },

  received(broadcast) {
    console.log('received')
    const {
      activeLocation,
      callerIdEnabled,
      currentConvoId,
      fetchCallDataFromBackend,
      fetchConversationMessages,
      hasDSO,
      hasRemindersTier2,
      markConvoUnseen,
      timeZone,
      updateConversationMessagesFromNotification,
      updateConversationDetails,
      updateMessage,
      userLocationIds,
    } = component.props

    const locationId = activeLocation && activeLocation.id
    const { channel } = broadcast
    switch (channel) {
      case 'Caller ID': {
        const dsoConditions =
          !broadcast.extension_location_ids.length ||
          broadcast.extension_location_ids.includes(locationId)

        if (!callerIdEnabled) break

        if (!hasDSO || (hasDSO && dsoConditions)) {
          callerIdNotification(component, broadcast, 'call')
        }

        break
      }
      case 'Call Log': {
        fetchCallDataFromBackend(moment(), timeZone, false, locationId)
        break
      }
      case 'Conversation': {
        let unknownWithMMS = false
        if (broadcast.message) {
          unknownWithMMS =
            !!broadcast.message.media_url &&
            broadcast.patient_name[0].match(/[a-z]/i) == null
        }
        const scopedToLocation = !hasDSO
          ? true
          : broadcast.location_ids.some(locId =>
              userLocationIds.includes(locId),
            )
        const showNotification =
          scopedToLocation &&
          (hasRemindersTier2 ||
            !!broadcast.message.body ||
            !broadcast.message.media_url) &&
          !unknownWithMMS
        if (callerIdEnabled && showNotification) {
          const { conversation } = broadcast
          markConvoUnseen(conversation.id)
          if (broadcast.message) {
            updateConversationMessagesFromNotification(
              conversation.messages,
              conversation,
            ).then(
              callerIdNotification(
                component,
                broadcast,
                conversation.messages_type,
              ),
            )
          } else {
            updateConversationDetails(broadcast.conversation).then(() => {
              fetchConversationMessages(broadcast.conversation.id).then(() => {
                callerIdNotification(
                  component,
                  broadcast,
                  conversation.messages_type,
                )
              })
            })
          }
        }
        break
      }
      case 'Delivery Status': {
        const { text_id: textId, status } = broadcast
        updateMessage(textId, status)
        break
      }
      case 'Message Sync': {
        const { conversation: convo } = broadcast
        if (currentConvoId === convo.id) {
          updateConversationMessagesFromNotification(convo.messages, convo)
        } else {
          updateConversationDetails(convo)
        }
        break
      }
      default: {
        console.log('unknown message received')
      }
    }
  },
})

class Socket extends Component {
  static propTypes = {
    debug: PropTypes.bool,
    channelName: PropTypes.string.isRequired,
  }

  constructor(props) {
    super(props)

    this.state = {
      isConnected: false,
      message: null,
    }

    // socket connections on instance
    this._consumer = null
  }

  componentDidMount() {
    const { debug, channelName } = this.props
    this._consumer = subscribeToChannel(channelName, createSocketCbs(this))

    if (debug) {
      window[`_consumer_${channelName}`] = this._consumer
    }
  }

  componentWillUnmount() {
    this._consumer.disconnected()
  }

  render() {
    return <div className="Socket" />
  }
}

const mapStateToProps = ({
  account: {
    user: { activeLocation, locations },
    auth: { hasRemindersTier2, hasDSO },
  },
  current: {
    conversation: { id: currentConvoId },
  },
  callLog: { timeZone, date },
  conversations: { messageType: convoMsgTypeFilter },
}) => ({
  activeLocation,
  convoMsgTypeFilter,
  currentConvoId,
  timeZone,
  date,
  hasRemindersTier2,
  hasDSO,
  userLocationIds: locations.map(loc => loc.id),
})

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      updateConversationMessagesFromNotification: (messages, convo) =>
        addMessagesToConversationFromNotification(messages, convo),
      setCurrentConvoFromNotification: convoId =>
        chooseCurrentConversation(convoId),
      updateConversationDetails: convo => storeConversationDetails(convo),
      fetchConversationMessages: convoId => getMessagesForConversation(convoId),
      setConversationType: type => setCurrConvoMsgType(type),
      setFilter: (menuId, menuType, view) => selectMenu(menuId, menuType, view),
      searchPatients: number => updatePatientSearch(number),
      updatePatientsAllLocations: checked =>
        updatePatientsAllLocations(checked),
      fetchCallDataFromBackend: (
        selectedDate,
        timeZone,
        changeDate,
        locationId,
      ) => fetchCoredialCalls(selectedDate, timeZone, changeDate, locationId),
      togglePopover: pageName => setPopoverPage(pageName),
      newContactInfo: (contactInfoType, value) =>
        setNewContactInfo(contactInfoType, value),
      updateMessage: (textId, status) => updateMessageStatus(textId, status),
      updateConvoMessageTypeFilter: msgType =>
        updateConversationMessageType(msgType),
      markConvoUnseen: addUnseenConvoId,
    },
    dispatch,
  )

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Socket))



// WEBPACK FOOTER //
// ./src/components/Socket.js